import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as v, S as g } from "./icons.types-0722eef5.js";
function p({ title: r, titleId: s, size: h, width: n, height: c, extended: o = !1, ...t }) {
  const i = o ? v : g, e = h ? i[h] : n || i[o ? "s" : "l"], a = h ? i[h] : c || i[o ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: e,
      height: a,
      "aria-labelledby": s,
      ...t,
      children: [
        r ? /* @__PURE__ */ l("title", { id: s, children: r }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Home_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M55.8 23.4h-9.84l-8.212-8.633c-.91-.941-2.583-.943-3.496.002L16.2 32.4v25.2h16.2V41.4h7.2v16.2h16.2V23.4ZM43.2 37.8H28.8V54h-9V34.2L36 18.142l11.052 11.78c.562.583 1.548.185 1.548-.625v-2.763h3.6V54h-9V37.8Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Home_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as Home
};
